import moment from "moment";

export function formatYearRange(isoDate, short = false) {
  const fmt = short ? 'YY' : 'YYYY';
  const m = moment(isoDate);
  const start = m.format(fmt);
  const end   = m.clone().add(1, 'year').format(fmt);
  return `${start}-${end}`;
}
export default formatYearRange;